export default __webpack_public_path__ + "static/media/openOrderGif1.b1bbd32b.gif";